export type CvEditionField = { path: Array<string | number>; label: string; section?: string; item?: number; value: string; multiline: boolean };
const object = (value: unknown): Record<string, unknown> => value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
const top = ['name', 'title', 'summary', 'bio', 'location', 'contactEmail'];
const groups: Record<string, string[]> = {
  experiences: ['title', 'company', 'location', 'employmentType', 'startDate', 'endDate', 'overview'],
  educations: ['school', 'degree', 'fieldOfStudy', 'startDate', 'endDate', 'description'],
  certifications: ['name', 'issuer', 'issueDate', 'expirationDate', 'credentialUrl'],
  highlights: ['title', 'desc'], projects: ['title', 'description', 'link'],
};
const long = new Set(['summary', 'bio', 'overview', 'description', 'desc', 'bullets']);
export function cvEditionFields(document: Record<string, unknown>): CvEditionField[] {
  const fields: CvEditionField[] = [];
  const add = (row: Record<string, unknown>, keys: string[], prefix: Array<string | number>, section?: string, item?: number) => {
    for (const key of keys) if (row[key] === null || typeof row[key] === 'string') fields.push({ path: [...prefix, key], label: key, section, item,
      value: typeof row[key] === 'string' ? row[key] as string : '', multiline: long.has(key) });
  };
  add(document, top, []);
  for (const [section, keys] of Object.entries(groups)) if (Array.isArray(document[section])) {
    (document[section] as unknown[]).forEach((item, index) => {
      const row = object(item);
      add(row, keys, [section, index], section, index + 1);
      if (Array.isArray(row.bullets)) row.bullets.forEach((bullet, number) => {
        if (typeof bullet === 'string') fields.push({ path: [section, index, 'bullets', number], label: 'bullets', section, item: index + 1, value: bullet, multiline: true });
      });
    });
  }
  if (Array.isArray(document.skillGroups)) document.skillGroups.forEach((item, index) => {
    const row = object(item);
    add(row, ['category'], ['skillGroups', index], 'skillGroups', index + 1);
    if (Array.isArray(row.items)) row.items.forEach((value, number) => {
      if (typeof value === 'string') fields.push({ path: ['skillGroups', index, 'items', number], label: 'skill', section: 'skillGroups', item: index + 1, value, multiline: false });
    });
  });
  if (Array.isArray(document.languages)) document.languages.forEach((value, index) => {
    if (typeof value === 'string') fields.push({ path: ['languages', index], label: 'language', value, multiline: false });
  });
  return fields;
}
export function changeCvEditionField(document: Record<string, unknown>, path: Array<string | number>, value: string) {
  if (!cvEditionFields(document).some((field) => JSON.stringify(field.path) === JSON.stringify(path))) throw new Error('Invalid edition field');
  const copy = JSON.parse(JSON.stringify(document)) as Record<string, unknown>;
  let parent: unknown = copy;
  for (const part of path.slice(0, -1)) parent = (parent as Record<string | number, unknown>)[part];
  (parent as Record<string | number, unknown>)[path.at(-1)!] = value;
  return copy;
}
export function editableCvEdition(document: Record<string, unknown>) {
  const { revision, revisionId, sourceRevisionId, sourceState, needsReview, variantId, canEdit, ...content } = document;
  return content;
}
